/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Fields_OptionalInputs */

const cs_templates_fields_optional = /** @type {(inputs: Templates_Fields_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelná`)
};

const en_templates_fields_optional = /** @type {(inputs: Templates_Fields_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Templates_Fields_OptionalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_fields_optional = /** @type {((inputs?: Templates_Fields_OptionalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Fields_OptionalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_fields_optional(inputs)
	return cs_templates_fields_optional(inputs)
});